$(document).ready(function () {
  $('a[href="https://www.instagram.com/not_tea_official/"]').attr(
    "target",
    "_blank"
  );
  var $switchImage = $(".banner__media.media img");
  function setImage() {
    if ($(window).width() <= 768) {
      $switchImage.attr("srcset", heroSpImageUrl);
    } else {
      $switchImage.attr("srcset", heroPcImageUrl);
    }
  }
  setImage();

  $(window).resize(function () {
    setImage();
  });

  //スクロール時の挙動変更
  var scrollThreshold = $(window).height();
  var spMenu = false;
  $(".header__icon--menu").on("click", function () {
    if (spMenu == true) {
      spMenu = false;
    } else {
      spMenu = true;
    }
    changeHeaderColor();
  });
  function changeHeaderColor() {
    // ヘッダースクロール色変更
    if (is_index) {
      if ($(window).scrollTop() <= scrollThreshold && !spMenu) {
        $(".header__heading-link img").attr("srcset", logoWhiteImageUrl);
        $(".icon-hamburger").css("color", "#FFF");
        $(".icon-close").css("color", "#FFF");
        let cart_count_bubble_props = {
          background: "#FFF",
          color: "#000",
        };
        $(".cart-count-bubble").css(cart_count_bubble_props);
        $(".icon-cart").css("color", "#FFF");
        $(".icon-cart-empty").css("color", "#FFF");
        $(".list-menu__item").css("color", "#FFF");
        $(".header-wrapper").css("background-color", "initial");
      } else {
        $(".header__heading-link img").attr("srcset", logoBlackImageUrl);
        $(".icon-hamburger").css("color", "#000");
        $(".icon-close").css("color", "#000");
        let cart_count_bubble_props = {
          background: "#000",
          color: "#FFF",
        };
        $(".cart-count-bubble").css(cart_count_bubble_props);
        $(".icon-cart").css("color", "#000");
        $(".icon-cart-empty").css("color", "#000");
        $(".list-menu__item").css("color", "#000");
        $(".header-wrapper").css("background-color", "#FFF");
      }
    }
  }
  //
  changeHeaderColor();

  $(window).scroll(function () {
    changeHeaderColor();
  });
  if (!is_index) {
    $(".header-wrapper").css("background-color", "#FFF");
  }
});
